"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const R = __importStar(require("ramda"));
class FragmentsSchemaContainer extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            introspectionQueryResultData: null,
            loading: true,
        };
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { uri } = this.props;
            this.setState({ loading: true });
            const introspectionQueryResultData = yield fetchFragmentsSchema(uri);
            this.setState({ loading: false, introspectionQueryResultData });
        });
    }
    render() {
        const { loading, introspectionQueryResultData } = this.state;
        const { children } = this.props;
        return children({ loading, introspectionQueryResultData });
    }
}
exports.FragmentsSchemaContainer = FragmentsSchemaContainer;
const fetchFragmentsSchema = (uri) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield fetch(uri, {
        body: JSON.stringify({
            operationName: 'FragmentsSchema',
            query: `
        query FragmentsSchema {
          __schema {
            types {
              kind
              name
              possibleTypes {
                name
              }
            }
          }
        }
      `,
        }),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
    })
        .then(result => result.json())
        .catch(() => ({ data: null }));
    if (R.isNil(result.data)) {
        return null;
    }
    const filteredData = result.data.__schema.types.filter((type) => type.possibleTypes !== null);
    result.data.__schema.types = filteredData;
    return result.data;
});
//# sourceMappingURL=FragmentsSchemaContainer.js.map